import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { GenericInteractiveMedia } from "../../models/resource/media"
import { UserService } from "../../services/user.service"
import { ModalService } from "../modal/modal.service"
import { LtiContinueModalComponent } from "../../resource/shared-components/lti-continue-modal/lti-continue-modal.component"
import { AddOnViewService } from "../../services/add-on-view.service"
import { Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"
import { CautionFlagsService } from "../../services/caution-flags.service"
import { InteractivePreviewModalComponent } from "../../resource/shared-components/interactive-preview-modal/interactive-preview-modal.component"
import { Asset, AssetOpenMode } from "../../models/resource/asset"

@Component({
    selector: "app-generic-interactive-preview",
    templateUrl: "./generic-interactive-preview.component.html",
    styleUrls: ["./generic-interactive-preview.component.scss"],
    standalone: false,
})
export class GenericInteractivePreviewComponent implements OnInit, OnDestroy {
    @Input() interactiveAsset: Asset
    isCautionFlagContainerDisplayed: boolean
    cautionFlagButtonName: string = "Launch Interactive"

    private destroyed$: Subject<void> = new Subject<void>()

    get genericInteractiveMedia(): GenericInteractiveMedia {
        return this.interactiveAsset?.selectedMedia as GenericInteractiveMedia
    }

    cautionFlagDisplayObservable: Observable<boolean> =
        this.cautionFlagsService.cautionFlagDisplayObservable.pipe(
            takeUntil(this.destroyed$),
            tap((nextState: boolean) => (this.isCautionFlagContainerDisplayed = nextState))
        )

    constructor(
        public userService: UserService,
        public addOnViewService: AddOnViewService,
        private modalService: ModalService,
        private cautionFlagsService: CautionFlagsService
    ) {}

    ngOnInit() {
        this.cautionFlagDisplayObservable.subscribe()
    }

    public expand(): void {
        if (this.isLTIMediaAndNotLoggedIn) {
            this.openLtiContinueModal()
        } else if (this.interactiveAsset.openMode === AssetOpenMode.IFRAME) {
            this.openFullWindowExperience()
        } else {
            window.open(this.genericInteractiveMedia.canonicalUrl, "_blank")
        }
    }

    private get isLTIMediaAndNotLoggedIn(): boolean {
        return this.genericInteractiveMedia.type === "lti" && !this.userService.isLoggedIn()
    }

    private openFullWindowExperience(): void {
        this.modalService.open(InteractivePreviewModalComponent, {
            data: {
                interactiveMedia: this.genericInteractiveMedia,
            },
        })
    }

    private openLtiContinueModal(): void {
        this.modalService.open(LtiContinueModalComponent, {
            data: {
                ltiMedia: this.genericInteractiveMedia,
                openMode: this.interactiveAsset.openMode,
            },
        })
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
